/**
 * Deterministic astrology + numerology helpers (zero LLM cost).
 * Mirrored from /app/backend/gemologist.py so the UI can compute & display
 * locally while the script endpoint runs in parallel.
 */

const ZODIAC = [
  { slug: "capricorn",   name: "Capricorn",   from: [12, 22], to: [1, 19],  element: "Earth", lucky: "Garnet",     energy: "disciplined, ambitious, timeless" },
  { slug: "aquarius",    name: "Aquarius",    from: [1, 20],  to: [2, 18],  element: "Air",   lucky: "Amethyst",   energy: "visionary, electric, independent" },
  { slug: "pisces",      name: "Pisces",      from: [2, 19],  to: [3, 20],  element: "Water", lucky: "Aquamarine", energy: "dreamlike, compassionate, oceanic" },
  { slug: "aries",       name: "Aries",       from: [3, 21],  to: [4, 19],  element: "Fire",  lucky: "Ruby",       energy: "bold, pioneering, ignited" },
  { slug: "taurus",      name: "Taurus",      from: [4, 20],  to: [5, 20],  element: "Earth", lucky: "Emerald",    energy: "grounded, sensual, enduring" },
  { slug: "gemini",      name: "Gemini",      from: [5, 21],  to: [6, 20],  element: "Air",   lucky: "Pearl",      energy: "curious, agile, expressive" },
  { slug: "cancer",      name: "Cancer",      from: [6, 21],  to: [7, 22],  element: "Water", lucky: "Moonstone",  energy: "intuitive, nurturing, lunar" },
  { slug: "leo",         name: "Leo",         from: [7, 23],  to: [8, 22],  element: "Fire",  lucky: "Peridot",    energy: "regal, radiant, generous" },
  { slug: "virgo",       name: "Virgo",       from: [8, 23],  to: [9, 22],  element: "Earth", lucky: "Sapphire",   energy: "precise, devoted, refined" },
  { slug: "libra",       name: "Libra",       from: [9, 23],  to: [10, 22], element: "Air",   lucky: "Opal",       energy: "balanced, aesthetic, harmonising" },
  { slug: "scorpio",     name: "Scorpio",     from: [10, 23], to: [11, 21], element: "Water", lucky: "Topaz",      energy: "magnetic, transformative, intense" },
  { slug: "sagittarius", name: "Sagittarius", from: [11, 22], to: [12, 21], element: "Fire",  lucky: "Turquoise",  energy: "expansive, philosophical, free" },
];

const BIRTHSTONE_BY_MONTH = {
  1: "Garnet", 2: "Amethyst", 3: "Aquamarine", 4: "Diamond",
  5: "Emerald", 6: "Pearl", 7: "Ruby", 8: "Peridot",
  9: "Sapphire", 10: "Opal", 11: "Citrine", 12: "Turquoise",
};

export const computeZodiac = (isoDate) => {
  if (!isoDate) return null;
  const [y, m, d] = isoDate.split("-").map((n) => parseInt(n, 10));
  if (!y || !m || !d) return null;
  // Capricorn wraps year-end
  if ((m === 12 && d >= 22) || (m === 1 && d <= 19)) {
    const z = ZODIAC[0];
    return { ...z, birthstone: BIRTHSTONE_BY_MONTH[m] };
  }
  const match = ZODIAC.find((z) => {
    if (z.slug === "capricorn") return false;
    const [fm, fd] = z.from;
    const [tm, td] = z.to;
    return (m === fm && d >= fd) || (m === tm && d <= td);
  }) || ZODIAC[3];
  return { ...match, birthstone: BIRTHSTONE_BY_MONTH[m] };
};

export const reduceToDigit = (n) => {
  while (n > 9 && n !== 11 && n !== 22 && n !== 33) {
    n = String(n).split("").reduce((a, c) => a + parseInt(c, 10), 0);
  }
  return n;
};

export const numerology = (fullName, isoDate) => {
  const out = {};
  if (isoDate) {
    const sum = isoDate.replace(/\D/g, "").split("").reduce((a, c) => a + parseInt(c, 10), 0);
    out.life_path = reduceToDigit(sum);
  }
  if (fullName) {
    let total = 0;
    for (const ch of fullName.toUpperCase()) {
      if (ch >= "A" && ch <= "Z") total += ((ch.charCodeAt(0) - 65) % 9) + 1;
    }
    out.destiny = reduceToDigit(total);
  }
  return out;
};
